import React from "react";

export function Infoin(){
  const title_color = {color : "white"}
  const code_color = {color: "grey" }
  return (
    <aside className="card-in">
      <br />
      <hgroup><h2>Índice</h2></hgroup><br />
      <blockquote cite="https://www.coronadosdelbien.com">
        <h6 style={title_color}><code style={code_color}>Sección 1:</code>ROBÓTICA EMPRESAS ECONOMÍA</h6>
      </blockquote><br />
      <blockquote cite="Droommk12"><h6 style={title_color}><code style={code_color}>Sección 2:</code>CIENCIA</h6></blockquote><br />
      <blockquote cite="Droommk12"><h6 style={title_color}><code style={code_color}>Sección 3:</code>ESPECIAL<code style={code_color}>{" "} Actualización</code></h6></blockquote><br />
      <blockquote cite="Droommk12"><h6 style={title_color}><code style={code_color}>Sección 4:</code>TECNOLOGÍA</h6></blockquote><br />
      <blockquote cite="Droommk12"><h6 style={title_color}><code style={code_color}>Sección 5:</code>MITO</h6></blockquote><br />
      <blockquote cite="Droommk12"><h6 style={title_color}><code style={code_color}>Sección 6:</code>DISPOSITIVOS</h6></blockquote><br />
      <blockquote cite="Droommk12"><h6 style={title_color}><code style={code_color}>Sección 7: </code>ESPACIO</h6></blockquote><br />
      <blockquote cite="https://www.coronadosdelbien.com">
        <h6 style={title_color}><code style={code_color}>Sección 8:</code>INTELIGENCIA ARTIFICIAL</h6>
      </blockquote><br />
    </aside>
  );
}
